import React from 'react';

import { Switch, Route, Router } from 'react-router-dom';

import history from '../config/history';
import { routes } from '../constants';

import ScrollToTop from './scroll-to-top.routing';
import AppRouting from './app.routing';
import CmsRouting from './cms.routing';

// DocumentHead is a wrapper around Helmet. See documentHead.js for more documentation around its use.
import DocumentHead from '../documentHead';

import { LoginPage } from '../CMS';

/**
 * this is the router setup.
 */
const Routing = () => (
	<Router history={history}>
		<ScrollToTop>
			<DocumentHead />
			<Switch>
				<Route path={`${routes.CMS.DEFAULT}${routes.CMS.LOGIN}`} component={LoginPage} />
				<Route path={routes.CMS.DEFAULT} component={CmsRouting} />
				<Route path={routes.HOME} component={AppRouting} />
			</Switch>
		</ScrollToTop>
	</Router>
);

export default Routing;



// WEBPACK FOOTER //
// ./src/router/routing.js